<template>
  <div>

    <div class="container-xl">
      <div class="logo">
        <router-link to="/personal"
          ><img src="../img/branogo2x.png" alt="" />会员专区</router-link
        >
      </div>
      <div class="Password">
        <h2>重设密码</h2>
        <div class="body2">
          <div class="body2-3">
            <el-input
              placeholder="请输入密码"
              v-model="newPassword"
              show-password
            ></el-input>
            <div class="body2-4">新密码</div>
          </div>
          <div>
            <div class="body2-5">
              <img src="../img/star234.png" alt="" />&nbsp;&nbsp;至少6位数
            </div>
            <div class="body2-5">
              <img src="../img/star234.png" alt="" />&nbsp;&nbsp;可包含字母数字
            </div>
          </div>
          <div class="body2-3-1">
            <el-input
              placeholder="请输入密码"
              v-model="newPassworda"
              show-password
            ></el-input>
            <div class="body2-4-1">再次确认新密码</div>
          </div>

          <button @click="sign" class="body2-8">重设密码</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { resetPassword } from "@/api/outpatient";
export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/change'
    },{
      rel:'alternate',
      href:'https://mybeame.com/change',
      hrefLang:'x-default'
    }
    ]
  },
  data() {
    return {
      newPassword: "",
      newPassworda: "",
      uresData: {},
    };
  },

  mounted() {
    // 获取本地储存数据
    this.data = JSON.parse(localStorage.getItem("data"));
  },

  methods: {
    //重置密码事件
    sign() {
      if (this.newPassword == "") {
        this.$message({
          message: "请输入密码",
          type: "warning",
        });
        return;
      }

      if (this.newPassworda != this.newPassword) {
        this.$message({
          message: "2次密码输入不正确",
          type: "warning",
        });
        return;
      }
      this.subData = Object.assign(this.uresData);
      var uresData = {
        password: this.newPassword,
      };
      //重置密码请求
      resetPassword(uresData).then((res) => {
        if (res.code == 200) {
          this.$dialog
            .alert({
              message: "成功重设密码",
            })
            .then(() => {
              this.$router.push("/personal");
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.logo {
  display: flex;
  align-items: center;
  padding: 8px 0;
  background: #00e467;
}
.logo > a {
  margin-left: 5%;
  font-weight: 700;
  font-size: 21px;
}
.logo > a > img {
  width: 28px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.Password {
  text-align: center;
  padding: 50px 0;
  background-image: url(../img/n1.png);
  background-size: 100%;
}
.Password > h2 {
  font-size: 32px;
  font-weight: 600;
  margin-top: 100px;
}
.body2 {
  width: 40%;
  margin: auto;
  padding-top: 40px;
  background-color: #ffffff;
}

.body2 >>> .el-input__inner {
  border: 3px solid #00e467 !important;
  border-radius: 10px;
  height: 45px;
}

.body2-1 {
  position: relative;
  margin-bottom: 50px;
}

.body2-3 {
  position: relative;
  margin-bottom: 20px;
}

.body2-4 {
  padding: 0 5px;
  height: 20px;
  background-color: #ffffff;
  position: absolute;
  left: 10px;
  top: -10px;
}

.body2-3-1 {
  position: relative;
  margin-top: 50px;
}

.body2-4-1 {
  padding: 0 5px;
  height: 20px;
  background-color: #ffffff;
  position: absolute;
  left: 10px;
  top: -10px;
}
.body2-5 {
  margin-top: 10px;
  text-align: left;
}

.body2-8 {
  width: 100%;
  height: 44px;
  font-size: 18px;
  background: #00e467;
  border: none;
  margin-top: 80px;
  cursor: pointer;
  font-weight: 600;
  border-radius: 0px 10px 0px 0px;
  color: #323e48 !important;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 570px) {
  .body2 {
    width: 90%;
  }
  .Password > h2 {
    font-size: 28px;
  }
  .Password {
    padding: 0 0 100px 0;
  }
}
</style>